import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthService } from '../../core/services/user.auth.service';

@Component({
    selector: 'home-layout',
    templateUrl: 'home-layout.component.html'
})

export class HomeLayoutComponent implements OnInit {
    userName: any;
    organisationName: any;
    ifSwitch;
    
    @Output() close = new EventEmitter<any>();
    public showDashboard ;
    constructor( private router:Router,
        private dataservice: UserAuthService) {
       
     }

    ngOnInit() {
       console.log("showDashboard",this.dataservice.ifShowDashboard);
       this.showDashboard = this.dataservice.ifShowDashboard;
       this.userName = this.dataservice.userName;
      
     }

     logout() {
this.router.navigate(['login',''])      }
    
}